import { createStore } from 'stimulus-store';

export const paperTypeStore = createStore({
    name: 'paperTypeStore',
    type: Object,
    initialValue: {}
});